/**
 * AAA IDP Licence Address
 * 
 */
import React from 'react';
import AddressFinder from '../address-finder/AddressFinder';
import AddressComponents from '../address-components/AddressComponents';
import ToggleAddressFields from '../toggle-address-fields/ToggleAddressFields';
import './LicenceAddress.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LABEL = 'Address on licence';
const NAME = 'licenceAddress';
const SECTION = 'licence-details';
export class LicenceAddress extends React.Component {
  render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "LicenceAddress",
      children: [/*#__PURE__*/_jsx(AddressFinder, {
        ...this.props,
        label: LABEL,
        name: NAME,
        section: SECTION
      }), /*#__PURE__*/_jsx(AddressComponents, {
        ...this.props,
        name: NAME,
        section: SECTION
      }), /*#__PURE__*/_jsx(ToggleAddressFields, {
        name: NAME
      })]
    });
  }
}
export default LicenceAddress;